import { gql } from '@apollo/client';

export default gql`
  mutation ProcessCardPaymentRefund(
    $bookingReference: String!
    $paymentLocation: String!
    $pspReference: String!
    $refundAmount: Float!
    $currency: Currency
    $hasHotel: Boolean
  ) {
    processCardPaymentRefund(
      bookingReference: $bookingReference
      paymentLocation: $paymentLocation
      pspReference: $pspReference
      refundAmount: $refundAmount
      currency: $currency
      hasHotel: $hasHotel
      location: EBSC
    ) {
      reference
      paymentsRefundBalance
    }
  }
`;
